export const enter = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
    visibility: hidden;
  }
  to {
    opacity: 1;
    transform: scale(1);
    visibility: visible;
  }
`

///////////////////////////////////////////////////////////////////////////////////

import { keyframes } from 'styled-components'
